"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.landbotDomainOfDeploymentEnv = exports.appSubdomainOfDeploymentEnv = exports.landbotSubdomainOfDeploymentEnv = exports.allDeploymentEnvironments = exports.DeploymentEnvironment = void 0;
const utility_1 = require("../utils/utility");
var DeploymentEnvironment;
(function (DeploymentEnvironment) {
    DeploymentEnvironment["DEV"] = "dev";
    DeploymentEnvironment["PROD"] = "prod";
})(DeploymentEnvironment || (exports.DeploymentEnvironment = DeploymentEnvironment = {}));
exports.allDeploymentEnvironments = (0, utility_1.allEnumValues)({
    [DeploymentEnvironment.DEV]: DeploymentEnvironment.DEV,
    [DeploymentEnvironment.PROD]: DeploymentEnvironment.PROD,
    local: "local",
});
exports.landbotSubdomainOfDeploymentEnv = {
    [DeploymentEnvironment.DEV]: "landroid",
    [DeploymentEnvironment.PROD]: "landbot",
};
exports.appSubdomainOfDeploymentEnv = {
    [DeploymentEnvironment.DEV]: "dev",
    [DeploymentEnvironment.PROD]: "app",
};
exports.landbotDomainOfDeploymentEnv = {
    [DeploymentEnvironment.DEV]: "https://landroid.mamahealth.com",
    [DeploymentEnvironment.PROD]: "https://landbot.mamahealth.com",
    local: "http://localhost:3000",
};
